import { Editor, Range, Transforms, Element as SlateElement } from 'slate';
import isUrl from 'is-url';

export const isMarkActive = (editor: any, format: any) => {
  const marks = Editor.marks(editor);

  return marks
    ? (marks as Record<string, unknown>)[format as string] === true
    : false;
};

export const isLinkActive = (editor: any) => {
  const [link] = Editor.nodes(editor, {
    match: (node: any) =>
      !Editor.isEditor(node) &&
      SlateElement.isElement(node) &&
      (node as SlateElement & { type?: string }).type === 'link',
  });

  return !!link;
};

export const isBlockActive = (editor: any, format: any, blockType: any) => {
  const { selection } = editor;

  if (!selection) {
    return false;
  }

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n: any) =>
        !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        (n as SlateElement & Record<string, unknown>)[blockType as string] ===
          format,
    }),
  );

  return !!match;
};

export const unwrapLink = (editor: any) => {
  Transforms.unwrapNodes(editor, {
    match: (node: any) =>
      !Editor.isEditor(node) &&
      SlateElement.isElement(node) &&
      (node as SlateElement & { type?: string }).type === 'link',
  });
};

export const wrapLink = (editor: any, url: any) => {
  if (isLinkActive(editor)) {
    unwrapLink(editor);
  }

  const { selection } = editor;

  const isCollapsed = selection && Range.isCollapsed(selection);

  const link = {
    type: 'link',
    url,
    children: isCollapsed ? [{ text: url }] : [],
  };

  if (isCollapsed) {
    Transforms.insertNodes(editor, link);
  } else {
    Transforms.wrapNodes(editor, link, { split: true });
    Transforms.collapse(editor, { edge: 'end' });
  }
};

export const withLinks = (editor: any, withToolbar: any) => {
  if (!withToolbar) {
    return editor;
  }

  const { insertData, insertText, isInline } = editor;

  editor.isInline = (element: any) =>
    (element as { type?: string }).type === 'link' ? true : isInline(element);

  editor.insertText = (text: any) => {
    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertText(text);
    }
  };

  editor.insertData = (data: any) => {
    const text = data.getData('text/plain');

    if (text && isUrl(text)) {
      wrapLink(editor, text);
    } else {
      insertData(data);
    }
  };

  return editor;
};
